"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var Story_1 = __importDefault(require("../../Story"));

var client_1 = __importDefault(require("../client"));

var useStyles_1 = __importDefault(require("./useStyles"));

var utils_1 = require("./utils");
/**
* Story generated by the Stories-API endpoint.
*/


var StoriesAPIStory = function StoriesAPIStory(_a) {
  var apiKey = _a.apiKey,
      collection = _a.collection,
      data = _a.data,
      endpoint = _a.endpoint,
      errorComponent = _a.errorComponent,
      id = _a.id,
      onLoad = _a.onLoad,
      options = _a.options;

  var _b = (0, react_1.useState)(false),
      loading = _b[0],
      setLoading = _b[1];

  var _c = (0, react_1.useState)(data),
      story = _c[0],
      setStory = _c[1];

  var _d = (0, react_1.useState)(false),
      error = _d[0],
      setError = _d[1];

  var classes = (0, useStyles_1.default)();
  (0, react_1.useEffect)(function () {
    if (data || story || loading) return; // Override API with passed in data

    setLoading(true);
    var client = new client_1.default(endpoint, apiKey);
    client.story("" + id, collection, undefined, undefined, function (storyData) {
      setStory(storyData);
      if (onLoad) onLoad(storyData);
      setLoading(false);
    }, function () {
      return setError(true);
    }).then();
  });

  var renderMoments = function renderMoments() {
    var storyMoments = [];
    story === null || story === void 0 ? void 0 : story.moments.forEach(function (moment) {
      if (utils_1.MomentUtils.isPublicMoment(moment)) {
        var index = storyMoments.length;
        var element = utils_1.MomentUtils.buildMoment(story, moment, index);
        if (element) storyMoments.push(element);
      }
    });
    return storyMoments;
  };

  var box = function box(body) {
    return react_1.default.createElement(Grid_1.default, {
      alignItems: "center",
      container: true,
      className: classes.box
    }, react_1.default.createElement(Grid_1.default, {
      item: true,
      xs: 12
    }, body));
  };

  var loader = (loading || !story) && box(react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Typography_1.default, {
    color: "primary",
    variant: "h5"
  }, "Building Your Story ..."), react_1.default.createElement(LinearProgress_1.default, {
    color: "secondary"
  })));

  var renderError = function renderError() {
    return errorComponent || box(react_1.default.createElement(Typography_1.default, null, "Something went wrong while loading this collection...", react_1.default.createElement("br", null), "Try Refreshing or Check Back Soon"));
  };
  /* eslint-disable react/jsx-props-no-spreading */


  return error ? renderError() : loader || react_1.default.createElement(Story_1.default, __assign({}, story, options), renderMoments());
};

StoriesAPIStory.propTypes = {
  /** API Key to interact with the StoriesAPI */
  apiKey: prop_types_1.default.string,

  /** StoriesAPI collection id */
  collection: prop_types_1.default.number,

  /** Override `StoriesAPI` data fetching to use custom data */
  // eslint-disable-next-line react/forbid-prop-types
  data: prop_types_1.default.object,

  /** `StoriesAPI` endpoint URL */
  endpoint: prop_types_1.default.string,

  /** Identifier of the `Story` */
  id: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]).isRequired,

  /** Props to pass to the `Story` component */
  // eslint-disable-next-line react/forbid-prop-types
  options: prop_types_1.default.object
};
StoriesAPIStory.defaultProps = {
  apiKey: undefined,
  collection: undefined,
  data: undefined,
  endpoint: undefined,
  options: {}
};
exports.default = StoriesAPIStory;